<template>
  <div class="list-latest-item">
    <div class="list-latest-item__top">
      <sc-text tag="h2" v-if="fields && fields.heading" :field="fields.heading" class="" />
      <sc-text tag="p" v-if="fields && fields.description" :field="fields.description" class="" />
      <sc-link
        v-if="fields && fields.cta"
        :field="fields.cta"
        class="c-cta--secondary"
        :class="fields.cta.value.class"
      />
    </div>
    <a :href="latestItemUrl" class="list-latest-item__link">
      <span class="type">Latest {{ latestItemLabel }}</span>
      <span class="date">{{ latestItemDate }}</span>
      <span class="title">{{ latestItemTitle }}</span>
      <span class="cta">{{ latestItemCtaLabel }}</span>
    </a>
  </div>
</template>

<script>
import { Text, Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-List-Landing-Item',
  components: {
    ScText: Text,
    ScLink: Link
  },
  props: {
    fields: {
      type: Object
    }
  },
  computed: {
    latestItemTitle() {
      return this.fields.latestItem?.fields?.resourceTitle?.value;
    },
    latestItemDate() {
      const date = new Date(this.fields.latestItem?.fields?.publishedAt?.value);
      const dateOptions = {
        weekday: undefined,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'UTC'
      };
      return date?.toLocaleDateString(undefined, dateOptions)?.replace(/[^0-9]/g, '.');
    },
    latestItemLabel() {
      return this.fields.latestItemLabel?.value;
    },
    latestItemCtaLabel() {
      return this.fields.latestItemCtaLabel?.value;
    },
    latestItemUrl() {
      return this.fields.latestItem?.url;
    }
  }
};
</script>
<style lang="scss" scoped>
.list-latest-item {
  width: 100%;
  @include add-Shadow;
  @include margin-x(0);
  margin-bottom: 3rem;

  @include tablet-up {
    display: flex;
    flex-flow: column nowrap;
    width: calc(100% / 2 - 2rem);
    margin-top: 4rem;
  }

  &__top {
    padding: 2.5rem 2.5rem 0 2.5rem;
  }

  &__link {
    margin-top: auto;
    display: block;
    width: 100%;
    padding: 2.5rem;
    background-color: $box-gray;
    transition: all 0.5s;

    &:hover {
      background-color: $blue;
      color: white;

      span {
        color: white;
      }

      .cta {
        &:after {
          background: url(~@/assets/images/icon-arrow-right-white-mobile.svg) no-repeat;
        }
      }
    }

    .type {
      @include font-styles('Arial Narrow', 1.4rem, 600, normal, 1.7rem, 0, $dark-blue);
      text-transform: uppercase;
      padding-right: 0.5rem;
    }

    .date {
      @include font-styles('Arial Narrow', 1.4rem, 600, normal, 1.7rem, 0, $dark-blue);
      text-transform: uppercase;
    }

    .title {
      display: block;
      @include font-styles('Arial', 2rem, 200, normal, 2.8rem, 0, $blue);
      margin-top: 0.5rem;
      margin-bottom: 1.5rem;
    }

    .cta {
      position: relative;
      display: block;
      @include font-styles('Arial Narrow', 1.8rem, 600, normal, 1.8rem, 0, $blue);
      text-transform: uppercase;

      &:after {
        content: '';
        display: inline-block;
        position: relative;
        background-image: url(~@/assets/images/icon-arrow-right-blue-sm.svg);
        background-repeat: no-repeat;
        background-size: contain;
        margin-left: 1rem;
        width: 1.9rem;
        min-width: 1.9rem;
        height: 1.5rem;
        min-height: 1.5rem;
        transition: 0.25s;
        top: 0.2rem;
        left: 0;
      }
    }
  }
}
</style>
